var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.86 2.08-.04.11-1.92 5.9H1.58c-.2 0-.37.13-.44.32-.05.18.02.39.18.5l5.11 3.71-1.95 6.01c-.06.19.01.4.17.51q.12.09.27.09c.15 0 .19-.03.27-.09l5.11-3.71V1.79c-.2 0-.38.1-.44.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.43 8.4a.44.44 0 0 0-.43-.31h-6.32l-1.95-6.01c-.06-.19-.25-.28-.44-.28v13.64l5.11 3.71q.12.09.27.09c.15 0 .19-.03.27-.09a.46.46 0 0 0 .17-.51l-1.95-6.01 5.11-3.71c.16-.12.23-.33.16-.52",
    opacity: 0.3
  })));
};
export default SvgHalfStar;